import { Typography, Box } from '@material-ui/core';
import clsx from 'clsx';
import { v4 as uuid } from 'uuid';

import { useStyles } from './styles';

interface TooltipBodyProps {
  backgrounds: string[];
  data: number[];
  labels?: string[];
}

export function TooltipBody({
  backgrounds,
  data,
  labels,
}: TooltipBodyProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {data.map((value, index) => (
        <div
          key={uuid()}
          className={clsx(classes.row, {
            [classes.disabled]: value === undefined,
          })}
        >
          <div
            className={classes.circle}
            style={{ backgroundColor: backgrounds[index] }}
          />
          <Box
            className={classes.labelsContainer}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            maxWidth="100%"
          >
            <Typography
              color="textSecondary"
              component="div"
              className={clsx(classes.label, classes.tooltipLabel)}
            >
              <span>{labels && (labels[index] ?? '--')}</span>
            </Typography>

            <Typography color="textSecondary" className={classes.label}>
              {value !== undefined && value !== null ? `${value}%` : '--'}
            </Typography>
          </Box>
        </div>
      ))}
    </div>
  );
}
